<template>
  <div class="manualMode">
    <heading level="4">
      {{ $t('statementCollect.manualUploadBlock.title') }}
    </heading>
    <div class="description">
      {{
        isBrokerFlow
          ? $t('statementCollect.manualUploadBlock.brokerContent')
          : $t('statementCollect.manualUploadBlock.content')
      }}
    </div>

    <div class="uploadedFiles" v-if="uploadedFiles.length">
      <uploaded-file
        v-for="(file, index) in uploadedFiles"
        :file="file"
        :key="index"
        class="file"
        @delete="deleteFile"
      />
    </div>
    <bank-statement-drop-zone
      :adr="adr"
      @picked="uploadFile"
      @delete="deleteFile"
      class="bankStatementsDropZone"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import BankStatementDropZone from '@/components/BankStatementDropZone';
import { ILLION_PRE_SUBMIT_ADR, ILLION_POST_SUBMIT_ADR } from '@/modules/illion-adrs';
import adrStatuses from '@/constants/adr-statuses';
import UploadedFile from '@/components/UploadedFile';
import applicationMixin from '@/mixins/application';
import brokerFlowMixin from '@/mixins/broker-flow';
import manualUploadConsents from '@/modules/manual-upload-consents';

export default {
  name: 'manual-verification',
  components: {
    BankStatementDropZone,
    UploadedFile,
  },
  props: {
    applicationConsents: {
      type: Array,
      required: true,
    },
  },
  mixins: [applicationMixin, brokerFlowMixin],
  data() {
    return {
      manualUploadConsents,
    };
  },
  computed: {
    ...mapGetters({
      filterFilesByQuery: 'file/filterFilesByQuery',
      allAdrs: 'adrs/getAdrs',
    }),
    consents: {
      get() {
        return this.applicationConsents.slice();
      },
      set(value) {
        this.$emit('updateConsents', value);
      },
    },
    uploadedFiles() {
      return this.filterFilesByQuery({ adrId: this.adr.id }).filter(file => file.isUploaded);
    },
    adr() {
      return (
        this.allAdrs.find(
          adr =>
            adr.status === adrStatuses.REQUESTED &&
            [ILLION_PRE_SUBMIT_ADR, ILLION_POST_SUBMIT_ADR].includes(adr.template.name),
        ) || {}
      );
    },
    consentsPath() {
      return 'statementCollect.manualUploadBlock.consents';
    },
  },
  methods: {
    ...mapActions('file', ['uploadFile', 'deleteFile']),
  },
};
</script>

<style lang="sass" scoped>
.uploadedFiles
  margin-top: $glass-spacing-3
  .file + .file
    margin-top: $glass-spacing-1

.description
  +font-size(13.33, 20)
  margin-top: $glass-spacing-105

.title
  margin-bottom: $glass-spacing-3
  +font-size(20)
  line-height: calc(28/20)
  font-weight: bold

.bankStatementsDropZone
  margin-top: $glass-spacing-3
  .text
    font-weight: normal
</style>
